/*
 * 3-А7 «Дубли и слияние» — числа из макета «Каталог и клиенты - П2»: полоса чипов 10 × 16,
 * пара — сетка 1fr 1fr 260 (ячейки 10 × 14, разделитель — малая линия сетки), действия
 * на фоне рабочего поля; сравнение — таблица 160 / 1fr / 1fr, строки 8 × 12; итог
 * зелёной плашкой 12 × 14 радиусом 10; конфликт — рамка с полосой 3 цвета «ждёт».
 */

.screen {
  display: flex;
  flex-direction: column;
  min-height: 100%;
  font-size: 12.5px;
}

.crumbs {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  min-height: 46px;
  padding: 0 16px;
  background: var(--bg-card);
  border-bottom: 1px solid var(--border);
}

.crumbLink {
  padding: 0;
  font: inherit;
  color: var(--text-secondary);
  cursor: pointer;
  background: none;
  border: 0;
}

.crumbSep {
  color: var(--text-secondary);
}

.crumbTitle {
  font-size: 15px;
  font-weight: var(--font-weight-semibold);
}

.headActions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-left: auto;
}

.toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  padding: 10px 16px 6px;
}

.sortNote {
  margin-left: auto;
  font-size: 12px;
  color: var(--text-secondary);
}

.list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 0 16px 16px;
}

.pair {
  display: grid;
  grid-template-columns: 1fr 1fr 260px;
  overflow: hidden;
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 10px;
}

.pairCell {
  min-width: 0;
  padding: 10px 14px;
  border-right: 1px solid var(--grid-line-minor);
}

.pairName {
  padding: 0;
  font: inherit;
  font-size: 13px;
  font-weight: var(--font-weight-semibold);
  color: var(--text-primary);
  text-align: left;
  cursor: pointer;
  background: none;
  border: 0;
}

.pairName:hover {
  text-decoration: underline;
}

.pairSub {
  font-size: 11.5px;
  font-variant-numeric: tabular-nums;
  color: var(--text-secondary);
}

.pairActions {
  display: flex;
  flex-direction: column;
  gap: 6px;
  justify-content: center;
  padding: 10px 14px;
  background: var(--bg-workspace);
}

.pairButtons {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.center {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  justify-content: center;
  padding: 48px 16px;
  text-align: center;
}

.centerTitle {
  font-size: 15px;
  font-weight: var(--font-weight-semibold);
}

.muted {
  font-size: 12.5px;
  line-height: 1.5;
  color: var(--text-secondary);
}

.more {
  align-self: center;
}

.outcome {
  padding: 10px 12px;
  margin: 10px 16px 0;
  line-height: 1.5;
  color: var(--hold-quarantine-fg);
  background: var(--hold-quarantine-bg);
  border-radius: 8px;
}

.problem {
  padding: 10px 12px;
  margin: 10px 16px 0;
  color: var(--danger-hover);
  background: var(--status-no-show-bg);
  border-radius: 8px;
}

/* ─────────── экран слияния ─────────── */

.merge {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 12px 16px 16px;
}

.mergeHead {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
}

.back {
  padding: 0;
  font: inherit;
  font-weight: var(--font-weight-semibold);
  color: var(--text-brand);
  cursor: pointer;
  background: none;
  border: 0;
}

.table {
  overflow: hidden;
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 10px;
}

.row {
  display: grid;
  grid-template-columns: 160px 1fr 1fr;
  align-items: center;
  border-bottom: 1px solid var(--grid-line-minor);
}

.row:last-child {
  border-bottom: 0;
}

.headRow {
  font-size: 10.5px;
  font-weight: var(--font-weight-semibold);
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--text-secondary);
  background: var(--bg-workspace);
  border-bottom: 1px solid var(--border);
}

.cell {
  display: flex;
  gap: 8px;
  align-items: center;
  min-width: 0;
  padding: 8px 12px;
}

.label {
  padding: 8px 12px;
  font-weight: var(--font-weight-semibold);
  color: var(--text-secondary);
}

.choice {
  display: flex;
  gap: 8px;
  align-items: center;
  padding: 0;
  font: inherit;
  color: var(--text-secondary);
  text-align: left;
  cursor: pointer;
  background: none;
  border: 0;
}

.choice[aria-checked="true"] {
  color: var(--text-primary);
}

.radio {
  flex: none;
  width: 14px;
  height: 14px;
  border: 1.5px solid var(--border-strong);
  border-radius: 50%;
}

.choice[aria-checked="true"] .radio {
  border: 4.5px solid var(--accent);
}

.phoneList {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.all {
  font-weight: var(--font-weight-semibold);
  color: var(--hold-quarantine-fg);
}

.mainChip {
  text-transform: none;
  letter-spacing: 0;
}

.summary {
  padding: 12px 14px;
  line-height: 1.55;
  color: var(--hold-quarantine-fg);
  background: var(--hold-quarantine-bg);
  border-radius: 10px;
}

.summary b {
  font-weight: var(--font-weight-semibold);
}

.conflict {
  padding: 10px 12px;
  color: var(--text-brand);
  border: 1px solid var(--border-strong);
  border-left: 3px solid var(--status-pending-fg);
  border-radius: 8px;
}

.inlineLink {
  padding: 0;
  margin-left: 6px;
  font: inherit;
  font-weight: var(--font-weight-semibold);
  color: inherit;
  text-decoration: underline;
  cursor: pointer;
  background: none;
  border: 0;
}

.footer {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: flex-end;
}

.dialogBody {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  min-width: min(460px, 100%);
}

.dialogButtons {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}

.found {
  display: flex;
  flex-direction: column;
  gap: 2px;
  max-height: 180px;
  overflow: auto;
}

.foundItem {
  display: flex;
  gap: 8px;
  justify-content: space-between;
  padding: 6px 8px;
  font: inherit;
  text-align: left;
  cursor: pointer;
  background: none;
  border: 1px solid transparent;
  border-radius: 6px;
}

.foundItem[aria-pressed="true"] {
  background: var(--bg-sunken);
  border-color: var(--border-strong);
}

@media (max-width: 767px) {
  .pair {
    grid-template-columns: 1fr;
  }

  .pairCell {
    border-right: 0;
    border-bottom: 1px solid var(--grid-line-minor);
  }

  .row {
    grid-template-columns: 1fr;
  }

  .label {
    padding-bottom: 0;
  }

  .headRow .label {
    display: none;
  }
}
